<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()"><mat-icon svgIcon="left-arrow"></mat-icon></div>
    <div class="header-text">Documents</div>
  </div>
  <div class="content">
    <div class="document-list-container">
      <div class="document-item personal-docs-item" (click)="navigateToPersonalDocuments()">
        <div class="icon-container">
          <mat-icon svgIcon="personal-docs"></mat-icon>
        </div>
        <div data-testid="personalDocs">
          <div class="document-title">Personal Documents</div>
        </div>
      </div>
      <div class="document-item training-docs-item" (click)="navigateToTrainingDocuments()">
        <div class="icon-container">
          <mat-icon svgIcon="training-docs"></mat-icon>
        </div>
        <div data-testid="T&C">
          <div class="document-title">Trainings & Certificates</div>
        </div>
      </div>
      <div class="document-item vehicle-docs-item" (click)="navigateToVehicleImages()">
        <div class="icon-container">
          <mat-icon svgIcon="vehicle-docs"></mat-icon>
        </div>
        <div data-testid="truck/trailer images">
          <div class="document-title">Truck / Trailer Images</div>
        </div>
      </div>
      <div class="document-item payroll-docs-item" (click)="navigateToPayrollDocuments()">
        <div class="icon-container">
          <mat-icon svgIcon="payroll-docs"></mat-icon>
        </div>
        <div data-testid="payroll documents">
          <div class="document-title">Payroll</div>
        </div>
      </div>
    </div>
  </div>
</div>